<template>
  <div class="dns-root">
    <div class="dns-input-row">
      <el-input v-model="domain" size="small" :placeholder="$t('tool.DnsLookup.phDomain')" class="dns-domain" @keyup.enter="query" />
      <el-select v-model="rtype" size="small" style="width:120px;">
        <el-option v-for="t in types" :key="t" :label="t" :value="t" />
      </el-select>
      <el-button type="primary" size="small" @click="query" :loading="loading">{{ $t('tool.DnsLookup.btnQuery') }}</el-button>
    </div>

    <div v-if="result" class="dns-result">
      <div class="dns-result-bar">{{ $t('tool.DnsLookup.result') }}：{{ result.length }}{{ $t('tool.DnsLookup.recordCount') }}</div>
      <table class="dns-table">
        <thead><tr><th>{{ $t('tool.DnsLookup.colIndex') }}</th><th>{{ $t('tool.DnsLookup.colType') }}</th><th>{{ $t('tool.DnsLookup.colValue') }}</th><th>{{ $t('tool.DnsLookup.colTtl') }}</th></tr></thead>
        <tbody>
          <tr v-for="(r, i) in result" :key="i">
            <td>{{ i + 1 }}</td>
            <td><span class="dns-type-tag">{{ r.type }}</span></td>
            <td><code>{{ r.data }}</code></td>
            <td>{{ r.TTL }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="error" class="dns-err">{{ error }}</div>

    <div v-if="!result && !error && !loading" class="dns-empty">{{ $t('tool.DnsLookup.emptyHint') }}</div>
  </div>
</template>

<script>
var RECORD_TYPES = ['A', 'AAAA', 'CNAME', 'MX', 'TXT', 'NS', 'SOA', 'PTR']

export default {
  name: 'DnsLookup',
  props: { config: { type: Object, default: function() { return {} } } },
  data: function() {
    return { domain: '', rtype: 'A', types: RECORD_TYPES, result: null, error: '', loading: false }
  },
  methods: {
    query: function() {
      var d = this.domain.trim()
      if (!d) return
      this.loading = true; this.result = null; this.error = ''

      var url = 'https://dns.google/resolve?name=' + encodeURIComponent(d) + '&type=' + this.rtype

      fetch(url)
        .then(function(r) { return r.json() })
        .then(function(data) {
          this.loading = false
          if (data.Answer) {
            this.result = data.Answer
          } else if (data.Authority) {
            this.result = data.Authority
          } else {
            this.result = []
            this.error = this.$t('tool.DnsLookup.errNoRecords')
          }
        }.bind(this))
        .catch(function(e) {
          this.loading = false
          this.error = this.$t('tool.DnsLookup.noResult') + ': ' + (e.message || this.$t('tool.DnsLookup.errNetworkError'))
        }.bind(this))
    },
    doAction: function(a) {
      if (a === 'clear') { this.domain = ''; this.result = null; this.error = '' }
      if (a === 'copy' && this.result) {
        var text = this.result.map(function(r) { return r.type + ' ' + r.data + ' (TTL ' + r.TTL + ')' }).join('\n')
        navigator.clipboard.writeText(text)
      }
    }
  }
}
</script>

<style>
.dns-root { width: 100%; }

.dns-input-row { display: flex; gap: 10px; align-items: center; }
.dns-domain { flex: 1; }
.dns-domain input { font-family: monospace; font-size: 14px !important; }

.dns-result { margin-top: 16px; }
.dns-result-bar { font-size: 13px; color: #606266; margin-bottom: 8px; }

.dns-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dns-table th, .dns-table td { padding: 8px 12px; text-align: left; border-bottom: 1px solid #ebeef5; }
.dns-table th { background: #fafbfc; color: #909399; font-weight: 600; }
.dns-table td code { font-family: monospace; font-size: 13px; color: #303133; word-break: break-all; }
.dns-type-tag { display: inline-block; padding: 1px 8px; border-radius: 3px; font-size: 12px; font-weight: 600; background: #e8f0fe; color: #4e7cff; }

.dns-err { margin-top: 16px; padding: 12px 16px; background: #fef0f0; border-radius: 8px; color: #f56c6c; font-size: 13px; }
.dns-empty { margin-top: 16px; text-align: center; padding: 40px; color: #c0c4cc; font-size: 14px; }
</style>
